import { render, staticRenderFns } from "./ProductExerptList.vue?vue&type=template&id=65c2bbf4&"
import script from "./ProductExerptList.vue?vue&type=script&lang=js&"
export * from "./ProductExerptList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductExerpt: require('/opt/build/repo/components/ProductExerpt.vue').default,AppHorizontalList: require('/opt/build/repo/components/AppHorizontalList.vue').default})
